"use client";
import React from "react";
import { HeaderConfig } from "./IndustryBenifitsGrid";

export default function IndustryBenifitsHeaderSection({
  header,
  ctaButton,
  theme = "dark",
}: {
  header: HeaderConfig;
  ctaButton?: React.ReactNode;
  theme?: "dark" | "light";
}) {
  const isDark = theme === "dark";

  return (
    <div className="flex flex-col items-start w-full gap-6">
      {/* Subtitle / Overline */}
      {header.subtitle && (
        <span
          className={`uppercase tracking-widest text-[length:var(--primarybtn)] font-medium transition-colors duration-300 ${
            isDark ? "text-white/60" : "text-[#1A4DB8]"
          }`}
        >
          {header.subtitle}
        </span>
      )}

      {/* Title & Description stacked full width */}
      <div className="flex flex-col justify-between w-full gap-8">
        <h2
          className={`text-[length:var(--section-title)] font-medium clash-font capitalize leading-[100%] transition-colors duration-300 ${
            isDark ? "text-white" : "text-[#0F172A]"
          }`}
        >
          {header.title}
        </h2>

        {header.description && (
          <p
            className={`text-[length:var(--hero-para)] leading-[160%] transition-colors duration-300 ${
              isDark ? "text-white/70" : "text-[#334155]"
            }`}
          >
            {header.description}
          </p>
        )}

        {ctaButton && (
          <div className="mt-2">
            {ctaButton}
          </div>
        )}
      </div>
    </div>
  );
}
